export enum ActorType {
  User = 1,
  Team = 2
}
